export default {"src":"/_next/static/media/user.562d522d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};